module.exports = __webpack_public_path__ + "PersonProfile-2_suxE3.svg";